export function movieBlockClick(event, element, youtubeId, embedCode) {
    event.stopPropagation();

  if (embedCode && embedCode !== "") {
    const srcMatch = embedCode.match(/src="([^"]+)"/);
    let srcValue = srcMatch ? srcMatch[1] : null;
    if (srcValue?.startsWith("http://")) {
      srcValue = srcValue.replace("http://", "https://");
    } else if (!srcValue?.startsWith("https://")) {
      srcValue = srcValue ? `https://${srcValue}` : null;
    }
    const isValidUrl = (urlString) => {
      try {
        new URL(urlString);
        return true;
      } catch (e) {
        return false;
      }
    };
    const secureSrc = isValidUrl(srcValue) ? srcValue : null;
    if (secureSrc) {
      window.open(secureSrc, "_blank");
    }
  } else {
    // Ensure CookieInformation is globally available or imported appropriately
    if (
      CookieInformation.getConsentGivenFor("cookie_cat_statistic") &&
      CookieInformation.getConsentGivenFor("cookie_cat_marketing")
    ) {
      element.removeAttribute("onclick");
      element.innerHTML =
        '<iframe src="https://www.youtube-nocookie.com/embed/' +
        youtubeId +
        '?showinfo=0&rel=0&enablejsapi=1&autoplay=1" frameborder="0" allow="autoplay; clipboard-write; fullscreen"></iframe>';
    } else {
      window.open("https://www.youtube.com/watch?v=" + youtubeId);
    }
  }
}

// Assign to global window for legacy usage
window.movieBlockClick = movieBlockClick;